import script from "./AcademyArticleRealtime1.vue?vue&type=script&setup=true&lang=js"
export * from "./AcademyArticleRealtime1.vue?vue&type=script&setup=true&lang=js"

import "./AcademyArticleRealtime1.vue?vue&type=style&index=0&id=840acfc4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-840acfc4"]])

export default __exports__